// extracted by mini-css-extract-plugin
module.exports = {"root":"_mYq1aM8X","high":"_KBlR0yta","medium":"_IGyGC0GH","low":"_BlOLSAY2","valueIcon":"_w3FQhLPh"};